import { render, staticRenderFns } from "./ServiceBanquetStep1.vue?vue&type=template&id=31f2b864"
import script from "./ServiceBanquetStep1.vue?vue&type=script&lang=js"
export * from "./ServiceBanquetStep1.vue?vue&type=script&lang=js"
import style0 from "./ServiceBanquetStep1.vue?vue&type=style&index=0&id=31f2b864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports